import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 10px;
`;

export const FileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 20px;
`;

export const WrapperFiles = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 20px;

  border: 1px solid #e0e0e0;
  border-radius: 4px;
`;

export const InputFile = styled.input`
  display: none;
`;

export const FileLine = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 0;
  width: 100%;

  p {
    font-size: 0.9rem;
    width: 300px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 10px;
    margin: 0;
  }

  p:nth-child(1) {
    text-align: left;
  }

  p:nth-child(3) {
    margin-left: 20px;
    width: 200px;
  }
`;

export const Icon = styled.div`
  width: 1.5rem;
  cursor: pointer;
  padding: 0 2px;
  margin: 0 10px;
`;

export const InputButton = styled.input`
  font-size: 0.9rem;
  padding: 8px 16px;
  background-color: #854ee0;
  border-radius: 4px;
  color: white;
  border: none;
  cursor: pointer;
  display: inline-block;

  &:hover {
    background-color: rgb(98, 54, 170);
  }
`;

export const InputContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Select = styled.select`
  border: 1px solid #ccc;
  border-radius: 4px;
  color: #333;
  font-size: 0.9rem;
  padding: 6px 8px;
  flex: 1;
  min-width: 300px;
  max-width: 650px;
  outline: none;

  &:focus {
    border-color: #854ee0;
  }
`;

export const LabelSavedFiles = styled.p`
  font-weight: bold;
  margin-bottom: 10px;
  font-size: 0.9rem;
`;

export const FileWrapperHeader = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  background-color: #ebebeb;
  padding: 10px 0 4px 0;
  border-radius: 4px;

  p:first-child {
    width: 340px;
    margin-left: 20px;
  }

  p:last-child {
    flex: 1;
    min-width: 300px;
    max-width: 650px;
  }
`;
